import { Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { PublicGuard } from './auth/guards/public.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'layout/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [PublicGuard],
    loadComponent: () => import('./auth/login/login').then(m => m.Login)
  },
  //{
  //  path: 'layout',
  //  canActivate: [AuthGuard],
  //  loadComponent: () => import('./layouts/home/home-layout').then(m => m.HomeLayout),
  //  children: [
  //    {
  //      path: 'dashboard',
  //      loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard)
  //    },
  //    {
  //      path: 'campaigns',
  //        loadComponent: () => import('./layouts/campaigns/campaigns').then(m => m.Campaigns),
  //      children: [
  //        {
  //          path: '',
  //          redirectTo: 'campaign',
  //          pathMatch: 'full'
  //        },
  //        {
  //          path: 'campaign',
  //          loadComponent: () => import('./layouts/campaigns/campaign/campaign').then(m => m.Campaign)
  //        },
  //        {
  //          path: 'campaign/:id',
  //          loadComponent: () => import('./layouts/campaigns/campaign-detail/campaign-detail').then(m => m.CampaignDetail)
  //        },
  //      ]
  //    },
  //    {
  //      path: 'sucursales',
  //      loadComponent: () => import('./layouts/sucursales/sucursales').then(m => m.Sucursales),
  //      children: [
  //        {
  //          path: '',
  //          redirectTo: 'sucursal',
  //          pathMatch: 'full'
  //        },
  //        {
  //          path: 'sucursal',
  //          loadComponent: () => import('./layouts/sucursales/sucursal/sucursal').then(m => m.Sucursal)
  //        },
  //        {
  //          path: 'cortes',
  //          loadComponent: () => import('./layouts/sucursales/cortes/cortes').then(m => m.Cortes)
  //        },
  //        {
  //          path: 'atributos',
  //          loadComponent: () => import('./layouts/sucursales/atributos/atributos').then(m => m.Atributos)
  //        },
  //        {
  //          path: 'autorizaciones',
  //          loadComponent: () => import('./layouts/sucursales/autorizaciones/autorizaciones').then(m => m.Autorizaciones),
  //        }
  //      ]
  //    },
  //    {
  //      path: 'skus',
  //      loadComponent: () => import('./layouts/skus/skus').then(m => m.Skus)
  //    },
  //    {
  //      path: 'configuration',
  //      loadComponent: () => import('./layouts/configuracion/configuracion').then(m => m.Configuracion)
  //    }
  //  ]
  //}
   {
    path: 'layout',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layouts/home/home-layout').then(m => m.HomeLayout),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'campaigns',
          loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard),
        children: [
          {
            path: '',
            redirectTo: 'campaign',
            pathMatch: 'full'
          },
          {
            path: 'campaign',
            loadComponent: () => import('./layouts/campaigns/campaign/campaign').then(m => m.Campaign)
          },
          {
            path: 'campaign/:id',
            loadComponent: () => import('./layouts/campaigns/campaign-detail/campaign-detail').then(m => m.CampaignDetail)
          },
        ]
      },
      {
        path: 'sucursales',
        loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard),
        children: [
          {
            path: '',
            redirectTo: 'sucursal',
            pathMatch: 'full'
          },
          {
            path: 'sucursal',
            loadComponent: () => import('./layouts/sucursales/sucursal/sucursal').then(m => m.Sucursal)
          },
          {
            path: 'cortes',
            loadComponent: () => import('./layouts/sucursales/cortes/cortes').then(m => m.Cortes)
          },
          {
            path: 'atributos',
            loadComponent: () => import('./layouts/sucursales/atributos/atributos').then(m => m.Atributos)
          },
          {
            path: 'autorizaciones',
            loadComponent: () => import('./layouts/sucursales/autorizaciones/autorizaciones').then(m => m.Autorizaciones),
          }
        ]
      },
      {
        path: 'medios',
        loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'espacios',
        loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'designs',
        loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'tickets',
        loadComponent: () => import('./layouts/dashboard/dashboard').then(m => m.Dashboard)
      },

      {
        path: 'configuration',
        loadComponent: () => import('./layouts/configuracion/configuracion').then(m => m.Configuracion)
      }
    ]
  }
  ,
  {
    path: '**',
    redirectTo: 'layout/dashboard'
  }
];
